import { Step, StepLabel, Stepper } from "@bvhi/ui-base";

interface Props {
  steps: string[];
  activeStep: number;
}

export const CatalogsCreateStepper = ({ activeStep, steps }: Props) => {
  return (
    <Stepper activeStep={activeStep}>
      {steps.map((label) => {
        const stepProps: { completed?: boolean } = {};
        return (
          <Step key={label} {...stepProps}>
            <StepLabel>{label}</StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};
